import { Component, OnInit } from '@angular/core';
import { AuthenticationService,FormService, ProfileService, AlertService,CompanyService} from '../_services/index';
import {Router, ActivatedRoute} from "@angular/router"
@Component({
  selector: 'app-forms',
  templateUrl: './forms.component.html',
  styleUrls: ['./forms.component.scss']
})
export class FormsComponent implements OnInit {
  private authorized:any;
  public questionList:any;
  public questionTypeList:any;
  public FormList:any;
  public QuestionTypeModal:any=false;
  public QuestionModal:any=false;
  public a:any;
  public list:any=2;
  public questionOne:any={
    name:'',
    description:''
  };
  public question:any={
    name:'',
    defaultWeighted: '',
    totalizable: true,
    type:''
  }
  public profile:any;
  constructor(
    public profileService: ProfileService,
    public companyService:CompanyService,
    public formService:FormService,
    public alertService:AlertService,
    private router: Router,
    public as: AuthenticationService,
    private route: ActivatedRoute,
  ) { 
    this.authorized = this.as.checkAuthentication();
      if(!this.authorized.authorized){
          this.router.navigate(['/login'])
      }
  }
  ngOnInit() {
    this.profileService.cast.subscribe(response => {
      this.profile = response;
    })
    this.getForm();
    this.getQuestion();
    this.getQuestionType();
  }
  url(path){
    this.router.navigate([path]);
  }
  changeType(type){
    this.list = type;
  }
  modalStatus(type,data){
    if(type == 'type'){
      if(this.QuestionTypeModal){
        this.QuestionTypeModal = false;
      }else{
        this.QuestionTypeModal = true;
        if(!data){
          this.questionOne={
            name:'',
            description:''
          };
        }else{
          this.getQuestionOneType(data);
        }
      }
    }else if(type == 'question'){
      if(this.QuestionModal){
        this.QuestionModal = false;
      }else{
        this.QuestionModal = true;
        if(!data){
          this.question={
            name:'',
            defaultWeighted: '',
            totalizable: true,
            type:''
          }
        }else{
          this.getQuestionOne(data)
        }
      }
    }
  }
  alert(data){
    this.alertService.updateAlert(data).subscribe(()=>{
        setTimeout(() => {
        this.alertService.deleteAlert().subscribe();
        }, 8000);
    })
  }

  getQuestionType(){
    this.formService.getQuestionTypeList().subscribe(response => {
      var data:any = response;
      if(data){
        if(!data.message){
          this.questionTypeList = response; 
        }
      }
    }, error => {
    })
  }
  getQuestionOneType(data){
    this.formService.getQuestionTypeOne(data).subscribe(response => {
        this.questionOne = response;
        if(!response){
            this.alert({reason:'No se ha podido cargar el tipo de pregunta.', type:"danger"});
            this.modalStatus('type','')
        }
    }, error => {
        this.alert({reason:'No se ha podido cargar el tipo de pregunta.', type:"danger"});
        this.modalStatus('type','')
    })
  }
  saveQuestionOneType(data){
    if(data.id){
        this.formService.updateQuestionTypeOne(data).subscribe(response => {
            this.alert({reason:'Tu tipo de pregunta ha sido actualizada con exito.', type:"success"});
            this.modalStatus('type','')
            this.getQuestionType()
        }, error => {
            this.alert({reason:'No se ha podido cargar el tipo de pregunta.', type:"danger"});
            this.modalStatus('type','')
        })
    }else{
        this.formService.newQuestionTypeOne(data).subscribe(response => {
            this.alert({reason:'Tu tipo de pregunta ha sido creada con exito.', type:"success"});
            this.modalStatus('type','')
            this.getQuestionType()
        }, error => {
            this.modalStatus('type','')
            this.alert({reason:'No se ha podido cargar el tipo de pregunta.', type:"danger"});
        })
    }
  }
  deleteQuestionOneType(data){
    this.formService.deleteQuestionTypeOne(data).subscribe(response => {
        this.alert({reason:'Tu tipo de pregunta ha sido eliminada con exito.', type:"success"});
        this.modalStatus('type','')
        this.getQuestionType()
    }, error => {
        this.modalStatus('type','')
        this.alert({reason:'Tu tipo de pregunta no ha sido eliminada, intentalo nuevamente.', type:"danger"});
    })
  }

  getQuestion(){
    this.formService.getQuestionList().subscribe(response => {
      var data:any = response;
      if(data){
        if(!data.message){
          this.questionList = response; 
        }
      }
    }, error => {
    })
  }
  getQuestionOne(data){
    this.formService.getQuestionOne(data).subscribe(response => {
        this.question = response;
        if(!response){
            this.alert({reason:'No se ha podido cargar la pregunta.', type:"danger"});
            this.modalStatus('question','')
        }
    }, error => {
        this.alert({reason:'No se ha podido cargar la pregunta.', type:"danger"});
        this.modalStatus('question','')
    })
  }
  saveQuestionOne(data){
    if(data.id){
        this.formService.updateQuestionOne(data).subscribe(response => {
            this.alert({reason:'La pregunta ha sido actualizada con éxito.', type:"success"});
            this.modalStatus('question','')
            this.getQuestionType()
        }, error => {
            this.alert({reason:'No se ha podido actualizar la pregunta.', type:"danger"});
            this.modalStatus('question','')
        })
    }else{
        this.formService.newQuestionOne(data).subscribe(response => {
            this.alert({reason:'La pregunta ha sido creada con éxito.', type:"success"});
            this.modalStatus('question','')
            this.getQuestionType()
        }, error => {
            this.modalStatus('question','')
            this.alert({reason:'No se ha podido cargar la pregunta.', type:"danger"});
        })
    }
  }
  deleteQuestionOne(data){
    this.formService.deleteQuestionOne(data).subscribe(response => {
        this.alert({reason:'La pregunta ha sido eliminada con éxito.', type:"success"});
        this.modalStatus('question','')
        this.getQuestion()
    }, error => {
        this.modalStatus('question','')
        this.alert({reason:'La pregunta no ha sido eliminada, intentalo nuevamente.', type:"danger"});
    })
  }


  getForm(){
    this.formService.getFormList().subscribe(response => {
      var data:any = response;
      if(data){
        if(!data.message){
          this.FormList = response; 
        }
      }
    }, error => {
    })
  }
  
}
